import { Component , Input} from '@angular/core';
import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderLoyaltyService } from 'src/app/_services/order-loyalty.service';

@Component({
    selector: 'app-tabit-order-info',
    templateUrl: './tabit-order-info.component.html',
    styleUrl: './tabit-order-info.component.scss',
    standalone: false
})
export class TabitOrderInfoComponent {
	@Input() options: any;
	$storage;

	constructor(
		public appService: AppService,
		public orderService: OrderService,
		public loyaltyService: OrderLoyaltyService,
	) {
		this.$storage = this.orderService.$storage;
	}


}
